"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryFilterOption = void 0;
const mobx_1 = require("mobx");
class CategoryFilterOption {
    constructor() {
        /**
         * Can be parent/variant category, undefined means no category selected, string means category selected
         */
        this.categoryIds = mobx_1.observable.map();
        this.setCategoryIds = (categoryIds) => {
            this.categoryIds.clear();
            categoryIds.forEach((categoryId) => {
                this.categoryIds.set(categoryId, null);
            });
        };
        this.reset = () => {
            this.categoryIds.clear();
        };
    }
    get isSet() {
        return this.categoryIds.size > 0;
    }
}
exports.CategoryFilterOption = CategoryFilterOption;
__decorate([
    mobx_1.observable,
    __metadata("design:type", Object)
], CategoryFilterOption.prototype, "categoryIds", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], CategoryFilterOption.prototype, "setCategoryIds", void 0);
__decorate([
    mobx_1.action,
    __metadata("design:type", Object)
], CategoryFilterOption.prototype, "reset", void 0);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], CategoryFilterOption.prototype, "isSet", null);
//# sourceMappingURL=CategoryFilterOption.js.map